/* eslint-disable react-hooks/exhaustive-deps */

import React, { FC, useContext, useEffect, useRef, useState } from 'react';
import appContext from '../../appContext';
import CustomizedSingleSelectDropdown from '../CreateForm/DropdownBase';
import CustomizedInput from '../CreateForm/InputBase';
import CustomizedSwitch from '../CreateForm/SwitchBase';
import './style.scss';

import { useMediaQuery } from '@mui/material';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { inputFormat } from '../../Utils/formFields';
import { ChooseYourFileButton, PrimaryButton, SecondaryButton } from '../Custom/Buttons';
import { hasFieldContainsName } from '../Slides/utils';

import {
  commonFileTypes,
  InputTypes,
  MultiInput,
  optionModeConstants,
  systemFields
} from "../../Utils/common";

import {
  CommonSectionContainer,
  CommonTitleSectionContainer,
  OptionSpacing,
  RadioSectionContainer,
  RadioTitleSectionContainer,
  TextboxSectionContainer,
  TextboxTitleSectionContainer,
  TitleSectionContainer,
} from "./styled";

import dayjs from 'dayjs';
import CustomizedDatePicker from '../CreateForm/DatePicketBase';
import DaysSelector from '../CreateForm/DatePicketBase/daysButton';
import FileUploadDialog from '../CreateForm/DialogBase/FileUploadDialog';
import CustomizedTimePicker from '../CreateForm/TimePickerBase';
import { decimalNumericRegex } from './constant';
import ConditionalInput from './OptionalComponents/ConditionalInput';
import './style.scss';
interface Props {
  NoOfOptions: number;
  value: any;
  selectedData: any;
  selectedType: string;
  fieldIndex: number | null;
  setFieldIndex: (e: number) => void;
  storeHistory: (field: string, value: any, type: string, optional?: any) => void;
  resetRedo: () => void;
  editUUID?: string;
  restrictAddInput?: boolean;
}

const Options: FC<Props> = ({ fieldIndex, selectedType, setFieldIndex, storeHistory, resetRedo, editUUID, restrictAddInput }) => {
  const isLessThan1280 = useMediaQuery("(max-width:1279px)");
  const { register, setValue, watch, control } = useFormContext()
  const [isConditionedDate, setConditionedDate] = useState<any>()
  const [uploadIdentifier, setUploadIdentifier] = useState<any>(null);

  const {
    removeIpOptions,
    addIpOptions,
    setAddIpOptions,
    setRemoveIpOptions,
    setAddChoiceTrigger,
    optionMode,
    setOptionMode
  } = useContext(appContext);

  const { remove, append, insert } = useFieldArray({
    control,
    name: "options",
  });
  const removeOptionRender = useRef(true)
  const addOptionRender = useRef(true)

  const addOption = () => {
    append(selectedType === "multi-input" ? {
      "question": "",
      "placeholder": "",
      "type": "textArea",
      "name": "",
      "isRequired": true,
      "rule": {}
    } : selectedType === "time" ?
      {
        "placeholder": "",
        "type": "time",
        "name": "",
        "isRequired": true,
        "rules": {
          "minTime": "",
          "maxTime": ""
        }
      }
      : {
        "label": "",
        "placeholder": "",
        "type": "textArea",
        "name": "",
        "isRequired": true,
        "allowedFileTypes": []
      });
    storeHistory('add-option-ip', watch(`options`)[watch(`options`).length - 1], "formsettings", { index: watch(`options`).length - 1 })
  };

  const removeOption = (ind: number) => {
    storeHistory('remove-option-ip', watch(`options`)[ind], "formsettings", { index: ind })
    remove(ind);
  }

  const handleOnUploadClose = (url: any) => {
    if (url) {
      setValue(uploadIdentifier, url);
      setUploadIdentifier(null);
    } else {
      setUploadIdentifier(null);
    }
  };

  const renderImageUpload = (ind: number) => {
    if (["image-multi-select", "image-select"].includes(selectedType)) {
      return (
        <>
          <TextboxSectionContainer>
            <TextboxTitleSectionContainer>Option image</TextboxTitleSectionContainer>
          </TextboxSectionContainer>

          <CustomizedInput
            placeholder="Type URL"
            value={watch(`options[${ind}].img`) ?? ""}
            onChange={(e: any) => {
              setValue(`options[${ind}].img`, e.target.value);
            }}
          />
          <FileUploadDialog
            open={Boolean(uploadIdentifier)}
            submitHandler={handleOnUploadClose}
            editUUID={"image-upload"}
          />
          <ChooseYourFileButton
            onClick={(e: any) => {
              e.preventDefault();
              setUploadIdentifier(`options[${ind}].img`);
            }}
          />
        </>
      );
    }

    return <React.Fragment />;
  };

  useEffect(() => {
    if (addOptionRender.current) {
      addOptionRender.current = false
      return
    }
    if (Object.keys(addIpOptions).length) {
      const optionData: any = addIpOptions

      insert(optionData?.index, (!optionData?.data || !optionData?.data?.type) ? inputFormat.options[0] : { ...inputFormat.options[0], ...optionData?.data })
      setAddIpOptions({})
    }

  }, [addIpOptions])

  useEffect(() => {
    if (removeOptionRender.current) {
      removeOptionRender.current = false
      return
    }
    if (Object.keys(removeIpOptions).length) {
      const optionsData: any = removeIpOptions
      remove(optionsData?.index)
      setRemoveIpOptions({})
    }
  }, [removeIpOptions])

  useEffect(() => {
    setOptionMode(optionModeConstants.basic);
  }, [selectedType]);

  const fieldHasAddOption = (index: number) => {
    return (
      ["select", "multi-select", "image-multi-select", "image-select"].includes(selectedType) &&
      index === watch(`options`)?.length - 1
    );
  };

  const fieldHasDeleteOption = () => {
    return (
      (selectedType === "input" || selectedType === "multi-input") &&
      watch(`options`)?.length > 1
    );
  };

  const fieldHasAddInputOption = (index: number) => {
    const notInput = !systemFields.includes(selectedType);

    return (
      notInput &&
      ["input", "multi-input", "time"].includes(selectedType) &&
      index === watch(`options`)?.length - 1
    );
  };

  const renderType = (keyOption: string, ind: any) => {
    if (
      keyOption === "type" &&
      (selectedType === "input" ||
        selectedType === "multi-input" ||
        selectedType === "nameAndSurname" ||
        selectedType === "domain" ||
        selectedType === "email" ||
        selectedType === "currency")
    ) {
      if (selectedType === "currency") {
        return (
          <TextboxSectionContainer>
            <TextboxTitleSectionContainer>Type</TextboxTitleSectionContainer>
            <CustomizedInput disabled={true} value="Currency" />
          </TextboxSectionContainer>
        );
      } else {
        return (
          <CommonSectionContainer isLargeScreen={!isLessThan1280} style={{ marginTop: "20px" }}>
            <CommonTitleSectionContainer isLargeScreen={!isLessThan1280}>
              Type
            </CommonTitleSectionContainer>
            <CustomizedSingleSelectDropdown
              value={watch(`options[${ind}].type`)}
              dataProvider={
                selectedType === "multi-input" ? MultiInput : restrictAddInput
                  ? InputTypes.filter((inputType: any) => inputType.value !== "file") : InputTypes
              }
              setValue={(e: string) => {
                storeHistory(
                  `options[${ind}].type`,
                  watch(`options[${ind}].type`),
                  "formsettings"
                );
                setValue(`options[${ind}].type`, e);
                resetRedo();
              }}
            />
          </CommonSectionContainer>
        );
      }
    }

    return <React.Fragment />;
  };

  const renderType2 = (keyOption: string, ind: any) => {
    if (
      keyOption === "type" &&
      (selectedType === "date" ||
        selectedType === "dateAndTime" ||
        selectedType === "phoneNumber")
    ) {
      return (
        <TextboxSectionContainer>
          <TextboxTitleSectionContainer>Type</TextboxTitleSectionContainer>
          <CustomizedInput
            disabled={true}
            value={selectedType}
            {...register(`options[${ind}].type`, { required: true })}
          />
        </TextboxSectionContainer>
      );
    }
    return <React.Fragment />;
  };

  const renderDateRules = (keyOption: string, ind: any) => {
    if (keyOption === "rules") {
      return (
        <React.Fragment >
          <TextboxSectionContainer>
            <TextboxTitleSectionContainer>Min Date</TextboxTitleSectionContainer>
            <div className={`conditional-container ${isConditionedDate?.[ind]?.rules?.minDate || isConditionedDate?.[ind]?.rules?.minDate === "" ? 'addcondition' : ""}`}>
              {isConditionedDate?.[ind]?.rules?.minDate || isConditionedDate?.[ind]?.rules?.minDate === "" ? <CustomizedDatePicker
                required={false}
                disabled={systemFields.includes(selectedType)}
                value={watch(`options[${ind}].rules.minDate`) ? dayjs(watch(`options[${ind}].rules.minDate`)) : ""}
                onChange={(e: any) => {
                  setValue(`options[${ind}].rules.minDate`, e);
                  setConditionedDate(watch(`options`))
                  resetRedo();
                }}
              /> :
                <ConditionalInput
                  value={watch(`options[${ind}].rules.minRule`)}
                  onChange={(e: string) => {
                    setValue(`options[${ind}].rules.minRule`, e);
                    setConditionedDate(watch(`options`))
                    resetRedo()
                  }}
                />
              }
              <button type="button" className='conditional-button' onClick={() => {
                const isConditionedDateClone = [...isConditionedDate].map((item: any) => {
                  return {
                    ...item,
                    rules: {
                      ...item.rules,
                      minRule: item?.rules?.minRule || item?.rules?.minRule === "" ? null : "",
                      minDate: item?.rules?.minRule || item?.rules?.minRule === "" ? "" : null,
                    }
                  }
                })
                setConditionedDate(isConditionedDateClone);
                setValue(`options`, isConditionedDateClone);
              }} >
                {isConditionedDate?.[ind]?.rules?.minRule !== null ? `Back` : `+ Add Condition`}
              </button>
            </div>
          </TextboxSectionContainer>
          <TextboxSectionContainer>
            <TextboxTitleSectionContainer>Max Date</TextboxTitleSectionContainer>
            <div className={`conditional-container ${isConditionedDate?.[ind]?.rules?.maxDate || isConditionedDate?.[ind]?.rules?.maxDate === "" ? 'addcondition' : ""}`}>
              {isConditionedDate?.[ind]?.rules?.maxDate || isConditionedDate?.[ind]?.rules?.maxDate === "" ? <CustomizedDatePicker
                required={false}
                disabled={systemFields.includes(selectedType)}
                value={watch(`options[${ind}].rules.maxDate`) ? dayjs(watch(`options[${ind}].rules.maxDate`)) : ""}
                onChange={(e: any) => {
                  setValue(`options[${ind}].rules.maxDate`, e);
                  setConditionedDate(watch(`options`))
                  resetRedo();
                }}
              /> :
                <ConditionalInput
                  value={watch(`options[${ind}].rules.maxRule`)}
                  onChange={(e: string) => {
                    setValue(`options[${ind}].rules.maxRule`, e);
                    setConditionedDate(watch(`options`))
                    resetRedo()
                  }}
                />
              }
              <button type="button" className='conditional-button' onClick={() => {
                const isConditionedDateClone = [...isConditionedDate].map((item: any) => {
                  return {
                    ...item,
                    rules: {
                      ...item.rules,
                      maxRule: item?.rules?.maxRule || item?.rules?.maxRule === "" ? null : "",
                      maxDate: item?.rules?.maxRule || item?.rules?.maxRule === "" ? "" : null,
                    }
                  }
                })
                setConditionedDate(isConditionedDateClone);
                setValue(`options`, isConditionedDateClone);
              }} >
                {!isConditionedDate?.[ind]?.rules?.maxRule || isConditionedDate?.[ind]?.rules?.maxRule === "" ? `+ Add Condition` : `Back`}
              </button>
            </div>
          </TextboxSectionContainer>
          <TextboxSectionContainer>
            <TextboxTitleSectionContainer>Days</TextboxTitleSectionContainer>
            <DaysSelector
              value={watch(`options[${ind}].rules.showDate`) || []}
              onChange={(e: any) => {
                setValue(`options[${ind}].rules.showDate`, e);
                resetRedo();
              }}
            />
          </TextboxSectionContainer>
        </React.Fragment >
      );
    }
    return <React.Fragment />;
  };


  const rendertimeRules = (keyOption: string, ind: any) => {
    if (keyOption === "rules") {

      return (
        <React.Fragment >
          <TextboxSectionContainer>
            <TextboxTitleSectionContainer>Min Time</TextboxTitleSectionContainer>
            <CustomizedTimePicker
              required={false}
              disabled={systemFields.includes(selectedType)}
              value={watch(`options[${ind}].rules.minTime`) ? dayjs(watch(`options[${ind}].rules.minTime`)) : null}
              onChange={(e: any) => {
                setValue(`options[${ind}].rules.minTime`, e);
                resetRedo();
              }}
            />
          </TextboxSectionContainer>
          <TextboxSectionContainer>
            <TextboxTitleSectionContainer>Max Time</TextboxTitleSectionContainer>
            <CustomizedTimePicker
              required={false}
              value={watch(`options[${ind}].rules.maxTime`) ? dayjs(watch(`options[${ind}].rules.maxTime`)) : null}
              onChange={(e: any) => {
                setValue(`options[${ind}].rules.maxTime`, e);
                resetRedo();
              }}
            />
          </TextboxSectionContainer>
        </React.Fragment>
      );
    }
    return <React.Fragment />;
  };

  const renderName = (keyOption: string, ind: any) => {
    if (keyOption === "name") {
      return (
        <TextboxSectionContainer>
          <TextboxTitleSectionContainer>Name</TextboxTitleSectionContainer>
          <CustomizedInput
            disabled={systemFields.includes(selectedType)}
            value={watch(`options[${ind}].name`)}
            onChange={(e: any) => {
              setValue(`options[${ind}].name`, e.target.value);
              resetRedo();
            }}
          />
        </TextboxSectionContainer>
      );
    }
    return <React.Fragment />;
  };

  const renderQuestion = (keyOption: string, ind: any) => {
    if (keyOption === "question" && selectedType === "multi-input") {
      return (
        <TextboxSectionContainer>
          <TextboxTitleSectionContainer>
            Question *
          </TextboxTitleSectionContainer>
          <CustomizedInput
            required={true}
            value={watch(`options[${ind}].question`)}
            onChange={(e: any) => {
              setValue(`options[${ind}].question`, e.target.value);
              resetRedo();
            }}
          />
        </TextboxSectionContainer>
      );
    }
    return <React.Fragment />;
  };

  const renderIsRequired = (keyOption: string, ind: any, type: string) => {
    if (keyOption === "isRequired") {
      return (
        <div className='isRequired-container'>
          <RadioSectionContainer>
            <RadioTitleSectionContainer>
              Required Field
            </RadioTitleSectionContainer>
            <CustomizedSwitch
              checked={watch(`options[${ind}].isRequired`)}
              changeHandler={(e: any) => {
                setValue(`options[${ind}].isRequired`, e?.target?.checked);
                storeHistory(`options[${ind}].isRequired`, !e?.target?.checked, "formsettings");
                resetRedo();
              }}
            />
          </RadioSectionContainer>
          {type === 'decimal' && <TitleSectionContainer>
            <TitleSectionContainer>
              Max visible Decimal
            </TitleSectionContainer>
            <CustomizedInput
              type="number"
              style={{ width: 75 }}
              value={watch(`options[${ind}].max_decimal`) ?? 2}
              onKeyPress={(e: any) => {
                e.key === 'e' && /^-?\d*$/.test(e?.target?.value) && e.preventDefault();
              }}
              onChange={(
                event: React.ChangeEvent<
                  HTMLTextAreaElement | HTMLInputElement
                >
              ) => {
                if (/^-?\d*$/.test(event?.target?.value)) {
                  setValue(`options[${ind}].max_decimal`, event?.target?.value);
                  resetRedo();
                }
              }}
            />
          </TitleSectionContainer>}
        </div>
      );
    }

    return <React.Fragment />;
  };

  const renderRule = (keyOption: string, ind: any, type: string) => {
    if (keyOption === "rule" && ['number', 'text'].includes(type)) {
      return (
        <RadioSectionContainer>
          <RadioTitleSectionContainer>
            Max limit character input
          </RadioTitleSectionContainer>
          <CustomizedInput
            type="number"
            style={{ width: 75 }}
            value={watch(`options[${ind}].rule.max`) ?? ""}
            onKeyPress={(e: any) => {
              e.key === 'e' && /^\d*$/.test(e?.target?.value) && e.preventDefault();
            }}
            onChange={(
              event: React.ChangeEvent<
                HTMLTextAreaElement | HTMLInputElement
              >
            ) => {
              if (/^\d*$/.test(event?.target?.value)) {
                setValue(`options[${ind}].rule.max`, event?.target?.value);
                resetRedo();
              }
            }}
          />
        </RadioSectionContainer>
      );
    }

    return <React.Fragment />;
  };

  const renderScore = (keyOption: string, ind: number) => {

    if (
      keyOption === "score" &&
      ["select", "multi-select"].includes(selectedType) &&
      ind !== null
    ) {
      return (
        <React.Fragment>
          <TitleSectionContainer>
            <TitleSectionContainer>
              Score
            </TitleSectionContainer>
            <CustomizedInput
              type="number"
              style={{ width: 75 }}
              value={watch(`options[${ind}].score`) ?? ""}
              onKeyPress={(e: any) => {
                e.key === 'e' && decimalNumericRegex.test(e?.target?.value) && e.preventDefault();
              }}
              onChange={(
                event: React.ChangeEvent<
                  HTMLTextAreaElement | HTMLInputElement
                >
              ) => {
                if (decimalNumericRegex.test(event?.target?.value)) {
                  setValue(`options[${ind}].score`, event?.target?.value);
                  resetRedo();
                }
              }}
            />
          </TitleSectionContainer>
        </React.Fragment>
      );
    }

    return <React.Fragment />;
  };

  const renderAddOptionButton = (ind: number) => {
    if (fieldHasAddOption(ind) && !restrictAddInput) {
      return (
        <div>
          <PrimaryButton
            style={{ width: 150, margin: "15px 0px" }}
            onClick={() => {
              setAddChoiceTrigger(true);
            }}
          >
            Add Option
          </PrimaryButton>
        </div>
      );
    }

    return <React.Fragment />;
  };

  const renderDeleteOptionButton = (ind: number) => {
    if (fieldHasDeleteOption()) {
      return (
        <div>
          <SecondaryButton
            style={{ width: 200, marginBottom: 15 }}
            onClick={() => {
              removeOption(ind);
              setFieldIndex(0);
            }}
          >
            Delete option
          </SecondaryButton>
        </div>
      );
    }

    return <React.Fragment />;
  };

  const renderAddInputOptionButton = (index: number) => {
    if (fieldHasAddInputOption(index) && !restrictAddInput) {
      return (
        <div>
          <PrimaryButton
            style={{ width: 200, marginBottom: 15 }}
            onClick={() => {
              addOption();
              resetRedo();
            }}
          >
            Add Field
          </PrimaryButton>
        </div>
      );
    }

    return <React.Fragment />;
  };

  const renderAllowedFileTypes = (keyOption: string, ind: any, type: string) => {
    if (keyOption === "allowedFileTypes" && type === "file") {
      return (
        <div className='AllowedFileTypes-container'>
          <CommonSectionContainer isLargeScreen={!isLessThan1280} style={{ marginTop: "20px" }}>
            <CommonTitleSectionContainer isLargeScreen={!isLessThan1280}>
              Allowed File Types
            </CommonTitleSectionContainer>
            <CustomizedSingleSelectDropdown
              isMulti={true}
              placeholder="Select file types"
              value={watch(`options[${ind}].allowedFileTypes`) || []}
              dataProvider={commonFileTypes}
              setValue={(newValues: any) => {
                setValue(`options[${ind}].allowedFileTypes`, newValues);
                storeHistory(`options[${ind}].allowedFileTypes`, newValues, "formsettings");
                resetRedo();
              }}
            />
          </CommonSectionContainer>
        </div>
      );
    }
    return <React.Fragment />;
  };

  const renderFieldPanel = (
    fieldProperties: any,
    fieldIndex: number,
    isFieldContainsName: boolean
  ) => {
    const entries = Object.entries(fieldProperties || {});
    if (fieldProperties?.type === 'file' && !Object.prototype.hasOwnProperty.call(fieldProperties, 'allowedFileTypes')) {
      entries.push(['allowedFileTypes', []]);
    }

    return entries.map(([keyOption, index]) => {
      if (isFieldContainsName) {
        if (optionMode === optionModeConstants.basic) {
          return (
            <React.Fragment>
              {renderType(keyOption, fieldIndex)}
              {renderType2(keyOption, fieldIndex)}
              {renderQuestion(keyOption, fieldIndex)}
              {renderRule(keyOption, fieldIndex, fieldProperties?.type)}
              {renderIsRequired(keyOption, fieldIndex, fieldProperties?.type)}
              {renderAllowedFileTypes(keyOption, fieldIndex, fieldProperties?.type)}
            </React.Fragment>
          );
        } else if (optionMode === optionModeConstants.advanced) {
          return (
            <React.Fragment>
              {renderName(keyOption, fieldIndex)}
              {['date', 'dateAndTime'].includes(fieldProperties.type) && renderDateRules(keyOption, fieldIndex)}
              {fieldProperties.type === 'time' && rendertimeRules(keyOption, fieldIndex)}
            </React.Fragment>
          );
        } else {
          return <React.Fragment />;
        }
      }

      return (
        <React.Fragment>
          {renderType(keyOption, fieldIndex)}
          {renderType2(keyOption, fieldIndex)}
          {renderName(keyOption, fieldIndex)}
          {renderQuestion(keyOption, fieldIndex)}
          {renderScore(keyOption, fieldIndex)}
          {renderIsRequired(keyOption, fieldIndex, fieldProperties?.type)}
          {renderAllowedFileTypes(keyOption, fieldIndex, fieldProperties?.type)}
        </React.Fragment>
      );
    });
  };

  useEffect(() => {
    setConditionedDate(watch('options'))
  }, [])

  return (
    <div className="options">
      <div className="option-tab">
        {fieldIndex !== null && (
          <div key={fieldIndex}>
            {watch(`options`)?.map((key: any, ind: number) => {
              const isFieldContainsName = hasFieldContainsName(selectedType);
              const actionFieldVisiblity = isFieldContainsName
                ? optionMode === optionModeConstants.basic
                : true;
              return (
                <OptionSpacing key={`${key.label}-${ind}`}>
                  {key?.type !== "otherField" && (
                    <TextboxTitleSectionContainer>
                      Option {ind + 1}
                    </TextboxTitleSectionContainer>
                  )}
                  {key?.type !== "otherField" &&
                    renderFieldPanel(key, ind, isFieldContainsName)}
                  {actionFieldVisiblity && key?.type !== "otherField" && renderImageUpload(ind)}
                  {actionFieldVisiblity && renderAddOptionButton(ind)}
                  {actionFieldVisiblity && renderDeleteOptionButton(ind)}
                  {actionFieldVisiblity && renderAddInputOptionButton(ind)}
                </OptionSpacing>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

export default Options